import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageLoader from "../commons/image-loader";
import { Loading } from "../../utility/loading";
import axios from "axios";
import styled from "styled-components";
import { equals } from "ramda";
import { getViewport } from "../../utility/get-viewport";

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
`

const SealImage = styled.img`
  max-width: 60px;
  position: absolute;
  right: 0;
  top: 30px;

  .related-projects & {
    max-width: 30px;
    top: 15px;
  }
  @media screen and (max-width: 768px) {
    max-width: 30px;
    top: 15px;
  }
`

export const PortfolioCard = (props) => {
  const isAcousticProjectByVicoustic = props.categories.some(equals('acoustic-project-by-vicoustic'))
  return (
    <Link className="product-card project-card" to={"/project/" + props.id}>
      <ImageWrapper>
        <ImageLoader
          shouldLoad={props.images && props.images.length > 0 ? true : false}
          source={
            props.images && props.images.length > 0
              ? getViewport(props.images[0].downloadURL, 'm')
              : ""
          }
          alt={props.name}
          ratio={"4:3"}
        />
        {isAcousticProjectByVicoustic && (
          <SealImage src="/resources/images/acoustic_project_vicoustic.png" />
        )}
      </ImageWrapper>
      <h3 style={{ fontSize: 18 }} data-text-color="black">
        <b>{props.name}</b>
      </h3>
      <p>{props.location}</p>
      <p>{props.shortSummary}</p>
    </Link>
  );
};

export const PortfolioCardWrapper = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [data, setData] = useState({});
  useEffect(() => {
    if (window.__SSRDATA && window.__SSRDATA[props.id]) {
      setData(window.__SSRDATA[props.id]);
      setIsLoading(false);
    } else {
      const getProject = () =>
        axios({
          method: "get",
          url: "/api/projects/" + props.id,
        });

      getProject()
        .then((result) => {
          setData(result.data);
          setIsLoading(false);
        })
        .catch((e) => {
          setHasError(true);
        });
    }
  }, [props.id]);

  return hasError ? null : isLoading ? (
    !props.hideLoading && <Loading />
  ) : (
    <PortfolioCard {...data} />
  );
};
